import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';
import mixins, { SvgClass } from '../../../../styles/mixins';

export const useStyles = makeStyles<Theme>()((theme) => ({
  exerciseItemWrapper: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.background.paper}`,
    borderRadius: 4,
    marginTop: 4,
    boxShadow: `0 1px 3px rgba(0, 0, 0, 0.1)`,

    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
      cursor: 'pointer',
    },
  },
  exerciseItemInfoWrapper: {
    padding: '16px 24px',
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  exerciseName: {
    fontWeight: 700,
    fontSize: 14,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  exerciseInfoWrapper: {
    marginLeft: 16,
    flex: 1,
  },
  exerciseItemHeaderButtonsWrapper: {
    display: 'flex',
    alignItems: 'center',
    ...mixins.appSvg,
  },
  expandIcon: {
    marginLeft: 32,
    ...mixins.appSvg,

    [`&.${SvgClass.expanded}`]: {
      transform: 'rotate(180deg)',
    },
  },

  exerciseItemDivider: {
    backgroundColor: theme.palette.grey[200],
  },

  exerciseItemContent: {
    padding: 24,
  },

  exerciseItemPropertyInline: {
    display: 'flex',

    '& svg:first-of-type': {
      marginLeft: 0,
    },
  },

  exerciseItemPropertyUseTimeIcon: {
    color: theme.palette.primary.main,
    marginRight: 16,
    marginLeft: 32,
  },

  exerciseItemPropertyUseWeightIcon: {
    color: theme.palette.primary.main,
    marginRight: 16,
    marginLeft: 32,
  },
  exerciseItemPropertyLabel: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '16px',
    marginRight: 4,
    color: theme.palette.grey[600],
  },

  exerciseItemPropertyValue: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '19px',
  },

  publishedStatusSuccess: {
    color: theme.palette.success.main,
  },

  publishedStatusReject: {
    color: theme.palette.error.main,
  },
  translationsError: {
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(1.5),
    background: theme.palette.error.main,
    color: theme.palette.primary.contrastText,
    width: 'fit-content',
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'flex-end',
  },
}));
